export default __webpack_public_path__ + "static/media/online.5e21b6bb.svg";